"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trimDecimals = exports.parseCurrencyValue = exports.getValidationsArray = exports.getCurrencySeparators = exports.currencySelectorStyles = void 0;

var _selectStyles = _interopRequireDefault(require("../styles/selectStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var currencySelectorStyles = _objectSpread(_objectSpread({}, _selectStyles.default), {}, {
  container: function container(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      minWidth: '9.5rem'
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      minWidth: 'unset',
      width: 'auto'
    });
  }
});

exports.currencySelectorStyles = currencySelectorStyles;

var trimDecimals = function trimDecimals(value, decimalSeparator, decimalScale) {
  if (!value) return '';

  var _value$split = value.split(decimalSeparator),
      _value$split2 = _slicedToArray(_value$split, 2),
      integerPart = _value$split2[0],
      decimalPart = _value$split2[1];

  var decimal = decimalPart === null || decimalPart === void 0 ? void 0 : decimalPart.slice(0, decimalScale);
  var amount = "".concat(integerPart).concat(decimal ? "".concat(decimalSeparator).concat(decimal) : '');
  return amount;
};

exports.trimDecimals = trimDecimals;

var parseCurrencyValue = function parseCurrencyValue(value, decimalSeparator, decimalScale) {
  var currencyTypeExpression = /[A-Z]{3}/m;
  var currencyTypeMatches = value.match(currencyTypeExpression);
  var currency = currencyTypeMatches ? currencyTypeMatches[0] : '';
  var formattedAmount = value ? value.replace(currency, '').replace('.', decimalSeparator).replace(',', decimalSeparator) : '';
  var amount = trimDecimals(formattedAmount, decimalSeparator, decimalScale);
  return {
    currency: currency,
    amount: amount
  };
};

exports.parseCurrencyValue = parseCurrencyValue;

var getCurrencySeparators = function getCurrencySeparators() {
  var formattingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var decimalScale = parseInt(formattingOptions.numOfDecimals) || 2;

  if (formattingOptions.thousandsSeparator) {
    return formattingOptions.decimalSeparator === ',' ? {
      thousandsSeparator: ".",
      decimalSeparator: ',',
      decimalScale: decimalScale
    } : {
      thousandsSeparator: ",",
      decimalSeparator: '.',
      decimalScale: decimalScale
    };
  }

  return {
    thousandsSeparator: false,
    decimalSeparator: formattingOptions.decimalSeparator,
    decimalScale: decimalScale
  };
};

exports.getCurrencySeparators = getCurrencySeparators;

var getValidationsArray = function getValidationsArray(dependencies, options, value, validations, validationDependency) {
  var _dependencies$validat;

  var validationDepKey,
      validationDepValue = {};

  if (validationDependency) {
    var _Object$values$;

    validationDepKey = Object.keys(validationDependency)[0];
    validationDepValue = (_Object$values$ = Object.values(validationDependency)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.toString();
  }

  var validationsArray = dependencies !== null && dependencies !== void 0 && (_dependencies$validat = dependencies[validationDepKey]) !== null && _dependencies$validat !== void 0 && _dependencies$validat[validationDepValue] ? !value ? [].concat(_toConsumableArray(dependencies[validationDepKey][validationDepValue]), _toConsumableArray(validations || [])) : validations : validations;
  if (options !== null && options !== void 0 && options.subType && !validationsArray.includes(options.subType)) validationsArray.push(options.subType);
  return validationsArray;
};

exports.getValidationsArray = getValidationsArray;